module.exports = __webpack_public_path__ + "static/img/home-stock.1feb90e5.png";